import React, { useEffect } from 'react';
import { Route, Switch } from "react-router-dom";

import { UserProvider } from "./context/UserContext";
import SecuredRoute from "./components/SecuredRoute";
import FmapHome from "./pages/home/FmapHome";
import AgentHome from "./pages/agents/AgentHome";
import AgentDashboard from "./pages/agents/AgentDashboard";
import ConsumerHome from "./pages/consumers/ConsumerHome";
import Login from "./pages/login/Login";
import Footer from "./components/Footer";
import Navbar from "./utils/NavBar";
import { makeStyles } from "@material-ui/core/styles";
import RetrieveApplicationDetails from "./pages/consumers/RetrieveApplicationDetails";
import UserConfirmation from "./pages/consumers/UserConfirmation";
import AgentRegistration from "./pages/agents/AgentRegistration";
import AgentAgreement from "./pages/agents/AgentAgreement";
import AvenirLTStd from "./fonts/AvenirLTStd-Light.woff";
import { createTheme, ThemeProvider } from "@material-ui/core";
import AgentSearchCriteriaCreateTile from "./pages/agents/AgentSearchCriteriaCreateTile";
import RegistrationConfirmation from "./pages/agents/RegistrationConfirmation";
import FmapConfiguration from "./pages/admin/FmapConfiguration";
import AgentSearch from "./pages/admin/AgentSearch";
import LeadSearch from "./pages/admin/LeadSearch";
import ListUsers from "./pages/admin/ListUsers";
import UnsuspendAgent from "./pages/admin/UnsuspendAgent";
import { CookiesProvider } from "react-cookie";
import AgentContactInfoView from "./pages/agents/AgentContactInfoView";
import Logout from "./pages/login/Logout";
import RetrieveApplicationDetailsGP from "./pages/consumers/RetrieveApplicationDetailsGP";
import ReactGA from "react-ga";
import AgentRegistrationGP from "./pages/agents/AgentRegistrationGP";

const useStyles = makeStyles((theme) => ({
  rootLead: {
    display: "flex",
    flexDirection: "column",
    minHeight: "85vh",
    backgroundColor: "#eaeef3",
  },
  root: {
    display: "flex",
    flexDirection: "column",
    minHeight: "50vh",
  },
  main: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(2),
  },
}));

const theme = createTheme({
  typography: {
    fontFamily: "AvenirLTStd, Roboto",
  },
  headerActive: {
    color: "#002e76",
    display: "inline",
    borderBottomStyle: "3px solid #002e76",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'AvenirLTStd', 'Roboto';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('AvenirLTStd-Light'),  url(${AvenirLTStd}) format('woff2');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
    },
  },
  palette: {
    error: {
      main: "#b94a48",
    },
  },
});

const useGooglePlaces = process.env.REACT_APP_USE_GOOGLE_PLACES;

function App() {
  const classes = useStyles();

  useEffect(() => {
    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_KEY);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CookiesProvider>
        <UserProvider>
          <div>
            <Navbar />
            <div className={classes.root}>
              <Switch>
                <Route exact path="/logout/:id?" render={() => <Logout />} />
                <Route exact path="/" render={() => <FmapHome />} />
                <Route
                  exact
                  path="/consumers"
                  render={() => (
                    <div className={classes.rootLead}>
                      <ConsumerHome />
                    </div>
                  )}
                />
                <Route exact path="/agents" render={() => <AgentHome />} />
                <Route path="/login" render={() => <Login />} />
                <Route
                  path="/agentAgreement"
                  render={() => <AgentAgreement />}
                />
                <Route
                  path="/agentRegistration"
                  render={() => <AgentRegistrationGP />}
                />
                {useGooglePlaces === true ||
                  (useGooglePlaces === "true" && (
                    <Route
                      path="/retrieve/:id?"
                      render={() => (
                        <div className={classes.rootLead}>
                          <RetrieveApplicationDetailsGP />
                        </div>
                      )}
                    />
                  ))}
                {useGooglePlaces !== true && useGooglePlaces !== "true" && (
                  <Route
                    path="/retrieve/:id?"
                    render={() => (
                      <div className={classes.rootLead}>
                        <RetrieveApplicationDetails />
                      </div>
                    )}
                  />
                )}
                <Route path="/confirm" render={() => <UserConfirmation />} />
                <Route
                  path="/agentConfirm/:id?"
                  render={() => <RegistrationConfirmation />}
                />
                <Route
                  path="/agentContactInformation/:id?"
                  render={() => <AgentContactInfoView />}
                />
                <SecuredRoute path="/agent-dashboard">
                  <AgentDashboard />
                </SecuredRoute>
                <SecuredRoute path="/fmapConfiguration">
                  <FmapConfiguration />
                </SecuredRoute>
                <SecuredRoute path="/agentSearch">
                  <AgentSearch />
                </SecuredRoute>
                <SecuredRoute path="/LeadSearch">
                  <LeadSearch />
                </SecuredRoute>
                <SecuredRoute path="/ListUsers">
                  <ListUsers />
                </SecuredRoute>
                <SecuredRoute path="/UnsuspendAgent">
                  <UnsuspendAgent />
                </SecuredRoute>
              </Switch>
            </div>
            <Footer />
          </div>
        </UserProvider>
      </CookiesProvider>
    </ThemeProvider>
  );
}

export default App;
